import * as React from "react";
import { loadStripe } from "@stripe/stripe-js";
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";
import { BASE_URL } from "../../services/api";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import useInvoice from "../../hooks/useInvoice";

const ManagePayment = ({isEmail}) => {
  const stripePromise = loadStripe(
    `pk_test_51Ppn9D06RIiEcWG3C37xvy70ZNZhfJXNOeALlCUl5MjJ120wiOOPfXZF2tdagz9NQWZcG8dhACRYcvpKCYVLxmqH00oCfuFJJm`
  );
const {id,invoiceId}=useParams()
const { detail } = useInvoice({ id, invoiceId });


  const { token } = useSelector((store) => store.auth);
  const fetchClientSecret = React.useCallback(() => {
    return fetch(`${BASE_URL}/api/Reports/InvPayment/CreateCheckoutSession`, {
      body: JSON.stringify({checkoutSessionList:isEmail?[{CCY: detail?.ccy,
        InvAmount: detail?.amount_Undispute,
        InvoiceNum: detail?.invoiceNumber,
        InvoiceId:detail?.id}]:JSON.parse(localStorage.getItem("InvoicePayInfo"))}),
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        localStorage.setItem("SessionId", data.sessionId);
        return data.clientSecret;
      });
  }, isEmail?[detail]:[]);
  const options = {
    fetchClientSecret: fetchClientSecret,
  };
  return (
    <>
    {(isEmail?Object.keys(detail || {})?.length>0:true) &&  <div id="checkout">
         <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
          <EmbeddedCheckout />
        </EmbeddedCheckoutProvider>
      </div>}
    </>
  );
};

export default ManagePayment;
